<template>
  <div class="col-span-1 w-full h-fit">
    <label :for="title" class="block text-sm font-medium leading-6 text-gray-900">
      <span class="flex gap-1 items-center">
        <span class="capitalize">{{ title }}</span>
        <Tooltip v-if="$slots['tooltip-content']">
          <TooltipTrigger as-child>
            <HelpCircle class="w-4 h-4 text-gray-400 cursor-help hover:text-gray-600" />
          </TooltipTrigger>
          <TooltipContent side="bottom">
            <slot name="tooltip-content" />
          </TooltipContent>
        </Tooltip>
        <span v-if="required" class="ml-1 text-red-500">*</span>
      </span>
    </label>
    <div class="mt-0.5 w-full h-full" :class="contentClass">
      <slot :label="title" />
    </div>
  </div>
</template>
<script lang="ts" setup>
import { HelpCircle } from "lucide-vue-next";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/shadcn-ui";

defineProps<{
  title: string;
  required?: boolean;
  contentClass?: string;
}>();
</script>
